var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealEstateAgent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3005_13844",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3005_13844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9004 29.925V13.65L28.3254 6.275L17.7754 13.65V20.425H14.9004V12.225L28.3254 2.625L41.7754 12.225V29.925H38.9004ZM29.3254 16.675H31.3254V14.675H29.3254V16.675ZM25.3254 16.675H27.3254V14.675H25.3254V16.675ZM29.3254 20.675H31.3254V18.675H29.3254V20.675ZM25.3254 20.675H27.3254V18.675H25.3254V20.675ZM12.7504 37.925L28.0504 42.425L40.3754 38.55C40.4087 37.85 40.1754 37.2792 39.6754 36.8375C39.1754 36.3958 38.5504 36.175 37.8004 36.175H27.4504C26.9004 36.175 26.3671 36.1333 25.8504 36.05C25.3337 35.9667 24.8337 35.8417 24.3504 35.675L19.6004 34.25L20.5254 31.325L25.246 32.925C25.6156 33.0583 25.9796 33.1542 26.3379 33.2125C26.6962 33.2708 27.0087 33.3 27.2754 33.3H30.2004C30.2004 32.6054 29.9671 31.995 29.5004 31.4687C29.0337 30.9424 28.4671 30.5445 27.8004 30.275L16.9754 26.175H12.7504V37.925ZM2.27539 43.75V23.3H16.9326C17.0977 23.3 17.2627 23.3125 17.4278 23.3375C17.5929 23.3625 17.7656 23.4078 17.946 23.4733L28.7504 27.55C30.0004 28.0167 31.0587 28.7375 31.9254 29.7125C32.7921 30.6875 33.2254 31.8833 33.2254 33.3H37.8004C39.4532 33.3 40.858 33.8958 42.015 35.0875C43.1719 36.2792 43.7504 37.7333 43.7504 39.45V40.65L28.3254 45.4L12.7504 40.95V43.75H2.27539ZM5.15039 40.875H9.82539V26.175H5.15039V40.875Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstateAgent);
export default __webpack_public_path__ + "static/media/real_estate_agent.83a0fe38e3a4a1d116fefac42c339b68.svg";
export { ForwardRef as ReactComponent };